import { create } from "zustand";

export type Testimonial = {
  id: number;
  avatar_image: string;
  name: string;
  position: string;
  testimony: string;
};

type TestimonialStore = {
  testimonials: Testimonial[];
  fetchTestimonials: (lang: "en" | "id") => Promise<void>;
};

const baseUrl = "https://admin.talentlinkindo.com/api";

export const useTestimonialStore = create<TestimonialStore>((set) => ({
  testimonials: [],

  fetchTestimonials: async (lang) => {
    try {
      const res = await fetch(`${baseUrl}/${lang}/testimonial`);
      if (!res.ok) throw new Error("Failed to fetch testimonials");

      const json = await res.json();
      set({ testimonials: json.data || [] });
    } catch (error) {
      console.error("Failed to fetch testimonials:", error);
    }
  },
}));
